export type NodeRange = { root: Document | ShadowRoot, parent: ParentNode, start: Node | null, end: Node | null }

export const getRoot = (node: Node) => {
  let result = node.getRootNode()
  if (result instanceof Element) return document
  return result as Document | ShadowRoot
}

export const children = (parent: ParentNode): NodeRange => ({ parent, start: null, end: null, root: getRoot(parent) })

export const after = (start: Node): NodeRange => ({ parent: start.parentNode!, start, end: start.nextSibling, root: getRoot(start.parentNode!) })

export const first = ({ start, parent }: NodeRange) => start ? start.nextSibling : parent.firstChild

export const next = (_: NodeRange, current: Node | null) => current?.nextSibling ?? null

export const done = ({ end }: NodeRange, current: Node | null) => current === end || !current

const tryMoveBefore = (parent: ParentNode, newChild: Node, refChild: Node | null) => {
  // @ts-ignore new API
  try { parent.moveBefore(newChild, refChild) }
  catch (e) { parent.insertBefore(newChild, refChild) }
}

export const insertBehind = ({ parent, end }: NodeRange, current: Node | null, newChild: Node) => {
  if (current === newChild) return newChild
  if (current === null) tryMoveBefore(parent, newChild, end)
  else tryMoveBefore(parent, newChild, current)
  return newChild
}
